import React, {Fragment} from "react";
import {dayColSpan, getDays, getSequenceNumber, getWeeks} from "./analyticsUtils";

export default function ({reportAnalytics, phase, enablePtoAnalytics}) {
  return (
    <tr>
      <th></th>
      {
        getWeeks(reportAnalytics.weeks[phase.guid], phase, reportAnalytics, enablePtoAnalytics).map(week => (
          <Fragment>
            {getDays(week.days, phase, week, reportAnalytics, enablePtoAnalytics).map(day => (
              <th data-align="center" key={week.numInPhase + day} colSpan={dayColSpan(reportAnalytics, phase, week, day, enablePtoAnalytics)}>{getSequenceNumber(reportAnalytics.reportMap[`${phase.guid}${week.weekNumber}${day}`])}</th>
            ))}
            <th data-align="center">Week</th>
          </Fragment>
        ))
      }
      {!enablePtoAnalytics && (
        <Fragment>
          <th data-align="center">Phase</th>
          <th data-align="center">Program</th>
        </Fragment>
      )}
    </tr>
  )
}
